export const engagementApiSuppressionLists = "/engagement/api/suppression_lists";
